import cn from 'clsx'

import { Button, Copy, ImageBox } from 'shared-components'

import { getSanityLink } from 'shared-functions'

import { type Cards as CardsType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './Cards.module.sass'

type ExtendedCardsType = CardsType & {
    icon: string
}

function Cards({ title, copy, image, cards, icon, noBorderBottom }: ExtendedCardsType) {
    return (
        <section className={cn(s.Cards, noBorderBottom && s.NoBorderBottom)}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Main}>
                    {title && <h2>{title}</h2>}
                    {copy && (
                        <div className={s.Copy}>
                            <Copy copy={copy} />
                        </div>
                    )}
                </div>
                {image && (
                    <div className={s.Image}>
                        {icon}
                        <ImageBox image={image} alt={title || ''} width={500} height={500} />
                    </div>
                )}
                {cards && cards?.length > 0 && (
                    <div className={s.CardsGrid}>
                        {cards?.map((card, index) => {
                            const { image, link, title, copy } = card

                            const _link =
                                link?.linkType === 'internal' || link?.linkType === 'external'
                                    ? getSanityLink(link) || null
                                    : null

                            return (
                                <div className={s.Card} key={index}>
                                    {image && (
                                        <div className={s.CardImage}>
                                            <ImageBox image={image} alt={title || ''} width={500} height={500} />
                                        </div>
                                    )}
                                    {title && <h3>{title}</h3>}
                                    <div className={cn(s.CardCopy, 'copy small')}>
                                        {copy && <Copy copy={copy} size="small" />}
                                        {_link && (
                                            <Button
                                                url={_link?.url || ''}
                                                title={_link?.title || ''}
                                                className={s.Link}
                                                noBorder
                                            />
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        </section>
    )
}

export default Cards
